import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setActivities = activities => {
	activities.data = activities.data.map(function(el) {
		el.start = new Date(el.start);
		el.end = new Date(el.end);
		return el;
	});

	return {
		type: ActionTypes.LOAD_ACTIVITIES,
		activities: activities.data
	};
};

export const loadActivities = date => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/solanasapi/calendar/")
			.then(response => {
				dispatch(setActivities(response.data));
			})
			.catch(error => {});
	};
};

export const saveActivities = activity => {
	return dispatch => {
		axios
			.post("http://190.105.227.203/solanasapi/calendar/", activity)
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};

export const updateActivities = activity => {
	return dispatch => {
		axios
			.patch("http://190.105.227.203/solanasapi/calendar/", activity)
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};

export const deleteActivity = activity => {
	return dispatch => {
		axios
			.delete("http://190.105.227.203/solanasapi/calendar/", {
				params: { id: String(activity.id) }
			})
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};
